import {createContext} from "react";

export const AppLoaderContext = createContext({
    loading: false,
    setLoading: () => {
    }
});
